import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import FormatCategories from "./components/FormatCategories";
import Trending from "./components/Trending";
import EditorPicks from "./components/EditorPicks";
import Themes from "./components/Themes";
import About from "./components/About";
import Faq from "./components/Faq";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <FormatCategories />
        <Trending />
        <EditorPicks />
        <Themes />
        <About />
        <Faq />
        <Subscribe />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}